export const adminUsers = [
    "admin@resumifi.com"
]